export default __webpack_public_path__ + "static/media/document-logo-1-active.7751ebd4.svg";